<template>
  <AutoDialogDrawer placement="centre" modal dismissible @close="$emit('close')">
    <template #title>{{ translate('Deactivate Login Policy') }}</template>
    <p>
      {{ translate('Are you sure you want to deactivate this login policy?') }}
      <strong class="text-nowrap">{{ translate('Version') }} {{ loginPolicy.version }}</strong>
    </p>
    <template #buttons>
      <BootstrapButton
        name="cancel"
        variant="secondary"
        :disabled="isDeactivating"
        @click="$emit('close')"
      >
        {{ translate('Cancel') }}
      </BootstrapButton>
      <BootstrapButton
        name="deactivate"
        variant="danger"
        :disabled="isDeactivating"
        @click="doDeactivate"
      >
        {{ translate('Deactivate') }}
      </BootstrapButton>
    </template>
  </AutoDialogDrawer>
</template>

<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';
import {useLocalisation} from '@/composables/useLocalisation';

const {translate} = useLocalisation();

const loginPolicyStore = useLoginPolicyStore();

const props = defineProps<{loginPolicy: LoginPolicy}>();
const emit = defineEmits<{close: []}>();

const isDeactivating = ref(false);

async function doDeactivate() {
  isDeactivating.value = true;
  try {
    await loginPolicyStore.deactivatePolicy(props.loginPolicy);
    emit('close');
  } finally {
    isDeactivating.value = false;
  }
}
</script>
